import gql from "graphql-tag";

export const createModel = gql`
  mutation createModel(
    $input: CreateModelInput!) {
    createModel(input: $input) {
      model {
        id
      }
      project {
        id
        models {
          id
          name
          status
          trialEnds
          cpu
          ram
          region
        }
      }
    }
  }
`;

export const createModelOptions = {
  name: "createModel",
};
